import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  USER_X_OUT_FIRST_MODAL: '6862',
  USE_GET_STARTED_FIRST_MODAL: '6863',
  CLAIM_PROPERTY_FROM_TOP: '6864',
  CLAIM_PROPERTY_FROM_BANNER: '6865',
  AFTER_CLAIMING_CONTACT_SALES_BANNER: '6874',
  INCREASE_YOUR_EXPOSURE: '6875',
  RELEASE_CLAIM: '6876',
  I_NO_LONGER_MANAGE: '6877',
  MY_COMPANY_NO_LONGER_MANAGES: '6878',
  I_CLAIMED_BY_MISTAKE: '6879',
} as const;

// https://dataportal.zillowgroup.net/event-registry/6862
export const ClaimDashboardUserXOutFirstModalEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.USER_X_OUT_FIRST_MODAL,
      event_type_version_id: '2',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'x_out_first_modal',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'user_x_out_first_modal',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6863
export const ClaimDashboardUseGetStartedFirstModalEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.USE_GET_STARTED_FIRST_MODAL,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'get_started',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'use_get_started_first_modal',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6864
export const ClaimDashboardClaimPropertyFromTopEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.CLAIM_PROPERTY_FROM_TOP,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'claim_a_property',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'claim_a_property_from_top',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6865
export const ClaimDashboardClaimPropertyFromBannerEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.CLAIM_PROPERTY_FROM_BANNER,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'start_claiming',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'claim_a_property_from_banner',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6874
export const ClaimDashboardAfterClaimingContactSalesBannerEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.AFTER_CLAIMING_CONTACT_SALES_BANNER,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'contact_sales',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'after_claiming_contact_sales_banner',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6875
export const ClaimDashboardIncreaseYourExposureEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.INCREASE_YOUR_EXPOSURE,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'increase_your_exposure',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'increase_your_exposure_on_claimed_property',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6876
export const ClaimDashboardReleaseClaimEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.RELEASE_CLAIM,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'release_claim',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'release_claim',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6877
export const ClaimDashboardINoLongerManageEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.I_NO_LONGER_MANAGE,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'i_no_longer_manage',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'release_claim_i_no_longer_manage',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6878
export const ClaimDashboardMyCompanyNoLongerManagesEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.MY_COMPANY_NO_LONGER_MANAGES,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'my_company_no_longer_manages',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'release_claim_my_company_no_longer_manages',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6879
export const ClaimDashboardIClaimedByMistakeEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.I_CLAIMED_BY_MISTAKE,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_property_summary',
      trigger_source_nm: 'i_claimed_by_mistake',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'release_claim_i_claimed_by_mistake',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// Clickstream visualizer data-eventid attributes
ClaimDashboardUserXOutFirstModalEvent.data_event_id = EVENT_IDS.USER_X_OUT_FIRST_MODAL;
ClaimDashboardUseGetStartedFirstModalEvent.data_event_id = EVENT_IDS.USE_GET_STARTED_FIRST_MODAL;
ClaimDashboardClaimPropertyFromTopEvent.data_event_id = EVENT_IDS.CLAIM_PROPERTY_FROM_TOP;
ClaimDashboardClaimPropertyFromBannerEvent.data_event_id = EVENT_IDS.CLAIM_PROPERTY_FROM_BANNER;
ClaimDashboardAfterClaimingContactSalesBannerEvent.data_event_id = EVENT_IDS.AFTER_CLAIMING_CONTACT_SALES_BANNER;
ClaimDashboardIncreaseYourExposureEvent.data_event_id = EVENT_IDS.INCREASE_YOUR_EXPOSURE;
ClaimDashboardReleaseClaimEvent.data_event_id = EVENT_IDS.RELEASE_CLAIM;
ClaimDashboardINoLongerManageEvent.data_event_id = EVENT_IDS.I_NO_LONGER_MANAGE;
ClaimDashboardMyCompanyNoLongerManagesEvent.data_event_id = EVENT_IDS.MY_COMPANY_NO_LONGER_MANAGES;
ClaimDashboardIClaimedByMistakeEvent.data_event_id = EVENT_IDS.I_CLAIMED_BY_MISTAKE;
